import EditorManager from './EditorManager'

var BS = window.BS || {}
BS.Editor = EditorManager
window.BS = BS

// import SelectionFormatTest from "./tests/SelectionFormatTest";
// SelectionFormatTest.run();
